import { Directive } from '@angular/core';
import { AbstractControl, FormGroup, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from "@angular/forms";

let zxcvbn = require('zxcvbn/dist/zxcvbn.js')

function validatePassword(): ValidatorFn {
  return (control: AbstractControl) => {
    let passwordValid = false;
    let passwordsMatch = false;
    let group = control as FormGroup;

    if (group.controls['password'] && group.controls['password'].value) {
      let passwordStrength = zxcvbn(group.controls['password'].value);
      passwordValid = passwordStrength.score >= 1;
    }

    if (group.controls['password'] && group.controls['password_confirm']) {
      passwordsMatch = group.controls['password'].value === group.controls['password_confirm'].value;
    }

    let result: any = {};

    if (!passwordValid) {
      result.passwordStrength = 'failed';
    } else if (!passwordsMatch) {
      result.passwordsMatch = 'failed';
    } else {
      return null;
    }

    return result;
  }
}

@Directive({
  selector: '[appCheckPassword]',
  providers: [{provide: NG_VALIDATORS, useExisting: CheckPasswordDirective, multi: true}]
})
export class CheckPasswordDirective implements Validator {

  private validateFn;

  constructor() {
    this.validateFn = validatePassword();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.validateFn(control);
  }

}
